import moment from "moment";

export function rosterMeasurementAverage(
	rows,
	playerIds,
	field,
	dateField,
	fromDate,
	toDate,
	now,
) {
	const grouped = new Map();
	let measurements = 0;
	for (const row of rows || []) {
		if (!playerIds.has(row.playerId) || !row[dateField]) continue;
		if (row[field] == null || row[field] === "") continue;
		const date = moment(row[dateField]);
		const value = parseFloat(String(row[field]).replace(",", "."));
		const min = field === "tqrValue" ? 6 : 1;
		const max = field === "tqrValue" ? 20 : 10;
		if (
			!date.isValid() ||
			date.isBefore(fromDate, "day") ||
			date.isAfter(toDate, "day") ||
			date.isAfter(now) ||
			!Number.isFinite(value) ||
			value < min ||
			value > max
		)
			continue;
		if (!grouped.has(row.playerId)) grouped.set(row.playerId, []);
		grouped.get(row.playerId).push(value);
		measurements++;
	}
	const means = [...grouped.values()].map(
		(values) => values.reduce((sum, value) => sum + value, 0) / values.length,
	);
	return {
		value: means.length
			? means.reduce((sum, value) => sum + value, 0) / means.length
			: null,
		players: means.length,
		measurements,
	};
}
